// import MegaNavbar from "../Components/MegaNavbar"
import secpic from "../assets/banner.jpg"
import aboutpic from "../assets/about.jpg"
import "../Components/MegaNavbar.css"

import 'bootstrap/dist/css/bootstrap.min.css'; 
import AOS from 'aos';
import {motion} from "framer-motion"

import Footer from "../Components/Footer";
import "aos/dist/aos.css"
import { useEffect } from "react";
import Aos from "aos";

import VcMsg from "../Components/VcMsg";
import OricStaff from "../Components/OricStaff";
import Acordon from "../Components/Acordon";
import Marquee from "../Components/Marquee";
import Icons from "../Components/Icons";
import MegaNavbar from "../Components/MegaNavbar";



const Home = () => {
    AOS.init();
    useEffect(()=>{
      Aos.init({duration: 2000})
  
    },[])
    
    return(
 <>


 <MegaNavbar/>
 





{/* Hero Section  */}
    <section id="hero" className="hero section">
      <img src={secpic} alt="" data-aos="fade-left" />
      
      <div className="container">
        <h2 data-aos="fade-up" data-aos-delay="100">
          Office of Research,<br />
          Innovation and Commercialization
        </h2>
        <p data-aos="fade-up" data-aos-delay="200">
          Shaheed Benazir Bhutto Women University Peshawar
        </p>
        <div className="d-flex mt-4" data-aos="fade-up" data-aos-delay="300">
          <a href="/" className="btn-get-started">Get Started</a>
        </div>
      </div>
    </section>
    {/* end hero section  */}


 {/* VC Message  */}
    
    <VcMsg/>


    {/* About us section  */}
        <motion.section 
          inherit={{x: -1000}}
          animate={{x: [900, 0]}}
          transition={{
          duration:"3",
          delay:"1"}}
          
        
        id="about" className="about section">
            <div className="container">
              
                <div className="row gy-4">
                    <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-up" data-aos-delay="100">
                        < img src={aboutpic} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-lg-6 order-2 order-lg-1 content" data-aos="fade-up" data-aos-delay="200">
                        <h3>Office of Research, Innovation & Commercialization (ORIC)</h3>
                        <p className="fst-italic">
                        Higher Education Commission aims to develop and sustain a dynamic and internationally competitive research sector in Pakistan that makes a major contribution to economic prosperity, national well being and the expansion and dissemination of knowledge. Promotion of Research is one of the core strategic aims of Higher Education Commission. Through the program and initiatives launched by Higher Education Commission for strengthening research and the process of knowledge creation, the quality and research output emanating from the universities and institutes in the country have shown tremendous improvements and Pakistan has been acknowledged as rising star in a number of research disciplines in terms of percentage increase in internationally cited research publications. Yet, this is no more than an end of a beginning and we need not only to sustain and improve this trend but also contemplate on questions of relevance and economic, social and academic impact of the research.

                         In pursuit of this end, Higher Education Commission has started working to organize the research activities of universities/HEIs ensuring availability of well-established and fully functional ORIC (Office of Research, Innovation and Commercialization). The ORICs will provide strategic and operational support to the University’s research activities/program, and will have a central role in facilitating the University’s research outcomes.
                             </p>
                    </div>
                </div>
            </div>
      
        </motion.section>
       
       {/* Card 1  */}
   
      <section>
      <div className="container">
    <div className="row ">
      <div className="col-md-6" data-aos="fade-right">
        <div className="card">
          <h5 className="card-header">VISION</h5>
          <div className="card-body">
            <h5 className="card-title">The ORIC-SBBWU envisions to</h5>
            <p className="card-text">The ORIC-SBBWU envisions to:

                           Promote quality research through academia-industry linkage for strong 
                           socio-economic impact, with a focus on research excellence, revenue generation,
                           and financial stability. By fostering innovation and facilitating the translation of 
                           research into practical applications, ORIC-SBBWU aims to drive sustainable development and enhance the community's overall well-being. Through strategic partnerships and collaborative efforts, the institution seeks to create a robust ecosystem that supports entrepreneurial ventures and cultivates a culture of continuous improvement in scientific endeavors. Additionally, ORIC-SBBWU is committed to empowering researchers and students by providing access to advanced resources and training programs. The center prioritizes addressing local and global challenges through interdisciplinary research initiatives.</p>
          </div>
        </div>
      </div>
      <div className="col-md-6" data-aos="fade-left">
        <div className="card mt-5 mt-md-0">
          <h5 className="card-header">MISSION</h5>
          <div className="card-body">
            <h5 className="card-title">ORIC-SBBWU serves as a platform for staff, faculty & research-oriented students to step forward and contribute to national sustainable progress by</h5>
            <p className="card-text">
              <ul>
                <li>Promoting an effective, innovative and entrepreneurial environment for technology-transfer and commercialization through purpose-led research centers, and dedicated Business Incubation Center to empower women.</li>
                <li>Strengthening academia-industry linkages through collaborative ventures with the aim to improve SBBWU curricula for meeting corporate standards to advance economic stability.</li>
                <li>Developing durable and long-term pledges with policy makers and research funding agencies to enhance the culture of research, ensure development and expand innovation & commercialization horizons.</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
      </section>
      <Acordon/>
      <OricStaff/>
      <Marquee/>
      <Icons/>
     
  <Footer/>    
    </>
  )
}

export default Home
